// gallery-sidebar.js
import { initGalleryListing } from './gallery-listing.js';

let currentProcedureId = null;

export function initGallerySidebar(selectedProcedureId = null) {
    currentProcedureId = selectedProcedureId;
    loadSidebarProcedures();
}

function loadSidebarProcedures() {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
                renderSidebar(response.data);
            } else {
                console.error('Failed to load procedures for sidebar');
            }
        }
    };
    xhr.send('action=get_procedures');
}

// Modify the renderSidebar function in gallery-sidebar.js
function renderSidebar(procedures) {
    // Create sidebar if it doesn't exist
    let sidebar = document.querySelector('.gallery-sidebar');
    if (!sidebar) {
        sidebar = document.createElement('div');
        sidebar.className = 'gallery-sidebar';
        
        // Insert sidebar before the patients container
        const patientsContainer = document.getElementById('patients-container');
        patientsContainer.parentNode.insertBefore(sidebar, patientsContainer);
    }

    let sidebarHtml = `
        <div class="gallery-sidebar__inner">
            <h3>Before & After Photos</h3>
            <div class="mobile-accordion">
                <button class="mobile-accordion__button" aria-expanded="false">
                    <span class="selected-text">Select Procedure</span>
                    <svg class="chevron" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>
                <div class="mobile-accordion__content" aria-hidden="true">
                    ${renderProcedureList(procedures)}
                </div>
            </div>
            <nav class="gallery-sidebar__nav">
                ${renderProcedureList(procedures)}
            </nav>
        </div>
    `;

    sidebar.innerHTML = sidebarHtml;

    // Add event listeners
    attachSidebarEvents(sidebar);
}

function attachSidebarEvents(sidebar) {
    sidebar.querySelectorAll('.procedure-link').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove current class from all links
            sidebar.querySelectorAll('.procedure-link').forEach(l => l.classList.remove('current'));
            
            // Add current class to clicked link
            this.classList.add('current');
            
            const procedureId = this.getAttribute('data-id');
            const procedureName = this.textContent.trim();
            const isParent = this.classList.contains('parent-link');
            
            // Update current procedure ID
            currentProcedureId = procedureId;
            
            // Initialize gallery listing with selected procedure
            initGalleryListing(procedureId, isParent, procedureName);
        });
    });
}

function renderProcedureList(procedures) {
    let html = '';
    procedures.forEach(function(group) {
        html += `
            <div class="procedure-group">
                <h3><a href="#" 
                   class="procedure-link parent-link ${group.parent_id == currentProcedureId ? 'current' : ''}"
                   data-id="${group.parent_id}">
                    ${group.parent_name}
                </a></h3>
        `;

        if (group.children.length > 0) {
            html += '<ul>';
            group.children.forEach(function(procedure) {
                html += `
                    <li>
                        <a href="#" 
                           class="procedure-link ${procedure.term_id == currentProcedureId ? 'current' : ''}"
                           data-id="${procedure.term_id}">
                            ${procedure.name}
                        </a>
                    </li>
                `;
            });
            html += '</ul>';
        }

        html += '</div>';
    });
    return html;
}

// Initialize mobile sidebar functionality
function initMobileSidebar() {
    const sidebar = document.querySelector('.gallery-sidebar');
    if (!sidebar) return;

    // Check if we're on mobile view
    if (window.innerWidth <= 1024) {
        // Add mobile class to sidebar
        sidebar.classList.add('is-mobile');

        const button = sidebar.querySelector('.mobile-accordion__button');
        const content = sidebar.querySelector('.mobile-accordion__content');
        
        if (button && content) {
            // Toggle accordion on button click
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', !isExpanded);
                content.setAttribute('aria-hidden', isExpanded);
                
                button.querySelector('.chevron')?.classList.toggle('open');
                content.classList.toggle('open');
            });

            // Update selected procedure
            content.addEventListener('click', (e) => {
                if (e.target.classList.contains('procedure-link')) {
                    const selectedText = e.target.textContent;
                    button.querySelector('.selected-text').textContent = selectedText;
                    
                    // Close accordion after selection
                    button.setAttribute('aria-expanded', 'false');
                    content.setAttribute('aria-hidden', 'true');
                    content.classList.remove('open');
                    button.querySelector('.chevron')?.classList.remove('open');
                }
            });

            // Close accordion when clicking outside
            document.addEventListener('click', (e) => {
                if (!sidebar.contains(e.target)) {
                    button.setAttribute('aria-expanded', 'false');
                    content.setAttribute('aria-hidden', 'true');
                    content.classList.remove('open');
                    button.querySelector('.chevron')?.classList.remove('open');
                }
            });

            // Update selected procedure if there is a current one
            const currentProcedure = sidebar.querySelector('.procedure-link.current');
            if (currentProcedure) {
                button.querySelector('.selected-text').textContent = currentProcedure.textContent;
            }
        }
    } else {
        // Remove mobile classes on desktop
        sidebar.classList.remove('is-mobile');
    }
}

// Function to handle the initialization
function initializeGallerySidebar() {
    // Run initialization
    initMobileSidebar();

    // Set up resize listener with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initMobileSidebar, 250);
    });
}

// Initialize on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGallerySidebar);
} else {
    initializeGallerySidebar(); // If DOMContentLoaded has already fired
}

// Handle gallery view changes
document.addEventListener('galleryViewChanged', initMobileSidebar);

// Make the initialization function available globally
window.initMobileSidebar = initMobileSidebar;

// Additional initialization when new content is loaded via AJAX
function reinitializeSidebar() {
    setTimeout(initMobileSidebar, 0);
}

// Add this to your existing AJAX success callbacks
if (typeof window.galleryCallbacks === 'undefined') {
    window.galleryCallbacks = {};
}
window.galleryCallbacks.sidebarInit = reinitializeSidebar;